import React, { useState, useEffect, useRef } from "react"
import { useSelector } from 'react-redux'
import { ListMsg } from './List'
import { DirectMessagingBEService } from 'src/_services'
export const GroupDetail = ({ isOpen, ...props }) => {
  const messagesEndRef = useRef(null)
  const [msg, setMsg] = useState(null)
  const [isTyping, setTyping] = useState(null)
  const DMStore = useSelector((state) => state.DirectMessaging);
  const message = DMStore?.message
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [isOpen]);
  useEffect(() => {
    scrollToBottom()
  }, [DMStore]);
  const send = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!msg) return
    new DirectMessagingBEService()
      .send(DMStore.client_id, { message: msg, type: 2 })
      .then(() => {
        setMsg('')
        scrollToBottom()
      })
  }
  const setValue = (e) => {
    setMsg(e.target.value)
  }
  return (
    <div className="contact-detail">
      <div className="contact bar">
        <div className="pic">{DMStore.room_name}</div>
        <div className="name">
          {DMStore.customer_name} - {DMStore.customer_phone}
        </div>
        <div className="seen">
          {DMStore.last_date_time}
        </div>
        <div className='close-btn' onClick={() => props.onClose()}>
          <i className="fas fa-times fa-1x"></i>
        </div>
      </div>
      <div className="messages" id="chat">
        <>
          <ListMsg message={message} type="Employee" />
        </>
        {isTyping &&
          <div className="message stark">
            <div className="typing typing-1"></div>
            <div className="typing typing-2"></div>
            <div className="typing typing-3"></div>
          </div>
        }
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={() => send()} className="input">
        {/* <i className="fas fa-camera"></i><i className="far fa-laugh-beam"></i> */}
        <input placeholder="Type your message here!" value={msg || ''} type="text"  onChange={(e) => setValue(e)} /><i className="fas fa-paper-plane" onClick={() => send()}></i>
      </form>
    </div>
  );
};
